export default function GestaoPortfolios() {
  return (
    <div className="bg-[#040116] text-white bg-[url(../assets/banner-gestao-porfolio.png)] bg-no-repeat bg-cover">
      <section className="container mx-auto w-full max-w-[1048px] flex flex-col gap-16 text-center pt-[185px] pb-[145px]">
        <h2 className="font-normal text-4xl group relative block w-fit mx-auto">
            GESTÃO DE PORTFÓLIOS DE PROJETOS
          <span className="absolute left-0 bottom-[-6px] h-[2px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full transition-all duration-200" />
        </h2>
        <p className="font-light text-3xl">
          <strong className="font-bold">Acompanhar e gerenciar</strong> os
          projetos em andamento na organização, <br /> garantindo que sejam
          corretamente priorizados de acordo com os <br />
          <strong className="font-bold">objetivos estratégicos</strong> da
          empresa.
        </p>
      </section>
    </div>
  )
}
